import { c as _c } from "react/compiler-runtime";
import { Card } from "@/components/Card";
import { Clock } from "@/components/Clock";
import { DownloadCV } from "@/components/DownloadCV";
import { HighlightedList } from "@/components/HighlightedList";
import { ProfileImage } from "@/components/ProfileImage";
import { SocialLinks } from "@/components/SocialLinks";
import { SectionTabs } from "@/components/section/contact/SectionTabs";
import { MapPinHouse } from "lucide-react";
const contactSectionContent = {
  title: "Contact Me",
  description: {
    text: "Get in touch with me to discuss opportunities or collaborations.",
    secondPart: "You can reach me via",
    highlights: ["LinkedIn", "GitHub", "Email"],
    end: "."
  },
  profile: {
    name: "Dimitar Daskalov",
    title: "Front End Developer",
    location: "Sofia, Bulgaria"
  },
  socials: {
    linkedin: "https://www.linkedin.com/in/dimitar-daskalov-a58594180/",
    github: "https://github.com/dimitar-daskalov",
    email: "mailto:dimitar.daskalov22@gmail.com"
  },
  skills: {
    items: [{
      name: "React",
      percentage: 96
    }, {
      name: "TypeScript",
      percentage: 95
    }, {
      name: "Tailwind CSS",
      percentage: 90
    }, {
      name: "Shadcn UI",
      percentage: 90
    }, {
      name: "Next.js",
      percentage: 90
    }, {
      name: "Node.js",
      percentage: 85
    }]
  },
  interests: {
    items: ["Web Development", "AI", "Music", "Investments", "Travel"]
  }
};
export const ContactSection = () => {
  const $ = _c(8);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <h1 id="contact-heading" className="heading-1 mb-6 text-glow">{contactSectionContent.title}</h1>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <br />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <header className="max-w-3xl text-center">{t0}<p className="body-large">{contactSectionContent.description.text}{t1}{contactSectionContent.description.secondPart}{" "}<HighlightedList items={contactSectionContent.description.highlights} />{contactSectionContent.description.end}</p></header>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  let t4;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ProfileImage size="sm" priority={false} className="mb-6" />;
    t4 = <h2 className="heading-2 mb-2 text-center lg:text-left">{contactSectionContent.profile.name}</h2>;
    t5 = <p className="body-base mb-4 text-center lg:text-left">{contactSectionContent.profile.title}</p>;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <address className="flex flex-col items-center lg:items-start flex-1 not-italic">{t3}{t4}{t5}<div className="flex items-center gap-1 mb-6" aria-label="Location"><MapPinHouse className="w-5 h-5" aria-hidden="true" /><span className="body-small">{contactSectionContent.profile.location}</span></div><SocialLinks ariaLabel="Social media links" containerClassName="mb-6" /><DownloadCV /></address>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <section aria-labelledby="contact-heading" className="w-full flex flex-col items-center gap-4 max-w-6xl">{t2}<Card hover={false} className="w-full p-8"><div className="flex flex-col lg:flex-row gap-4 md:gap-12 items-stretch">{t6}<aside className="flex flex-col flex-1 min-h-0" aria-label="Skills and interests"><Clock /><SectionTabs skills={contactSectionContent.skills.items} interests={contactSectionContent.interests.items} /></aside></div></Card></section>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  return t7;
};